import { render, staticRenderFns } from "./general.vue?vue&type=template&id=4fad0fb4&scoped=true&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fad0fb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fad0fb4')) {
      api.createRecord('4fad0fb4', component.options)
    } else {
      api.reload('4fad0fb4', component.options)
    }
    module.hot.accept("./general.vue?vue&type=template&id=4fad0fb4&scoped=true&", function () {
      api.rerender('4fad0fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/maps/general.vue"
export default component.exports